import requestData from "./requestData";

class eventService {
    getItems = () => requestData("GET", `/api/events`);
}

export default new eventService();